import React from 'react';

const AssetManagement = () => {
    return (
        <div style={{ padding: '40px 15px' }}>
            <h3>Nội dung về Dịch vụ Quản lý và khai thác tài sản</h3>
            <p>Chi tiết về lĩnh vực này sẽ được trình bày ở đây...</p>
        </div>
    );
};

export default AssetManagement;